import {
  DashboardOutlined,
  FileTextOutlined,
  ReloadOutlined,
  UserOutlined,
} from "@ant-design/icons";

/*
    Object structure:
        - label: Used in side menu & breadcrumbs. Also used for page name
        - icon: Used in side menu & breadcrumbs
    
    You must break down all paths into subroutes. For example, the path /applications/search must be broken down into:
        - "/applications"
        - "/search"

    If you want to give a custom name to a specific page, you can add an entry for the full path as well:
        - "/applications/search": { label: "Search Applications" }    
*/
export const privatePagesMap = {
  /* Common pages */
  "/view": { label: "View" },
  "/edit": { label: "Edit" },
  "/search": { label: "Search" },
  /* Main pages */
  "/applications": { label: "Applications", icon: <FileTextOutlined /> },
  "/renewals": { label: "Renewals", icon: <ReloadOutlined /> },
  "/quote": { label: "Quote" },
  "/users": { label: "Users", icon: <UserOutlined /> },
  "/dashboard": {
    label: "Dashboard",
    icon: <DashboardOutlined />,
    name: "KPIs & conversion rates dashboard",
  },
  "/view-previous-quote": { label: "Previous quote" },
  "/send-email": { label: "Compose email" },
  "/email-template": { label: "Email template" },
  /* Specific page names */
  "/applications/search": { label: "Search Applications" },
  "/applications/view": { label: "View application" },
  "/applications/edit": { label: "Edit application" },
  "/renewals/search": { label: "Search Renewals" },
  "/renewals/view": { label: "View renewal" },
  "/renewals/edit": { label: "Edit renewal" },
  "/renewals/send-email": { label: "Compose renewal email" },
  "/renewals/email-template": { label: "Renewal email template" },
};
